import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { Row, Col} from 'react-bootstrap';
import { Button, Table, TableBody, TableCell, TableContainer, TableRow, Chip } from '@mui/material';
import { useEffect } from "react";
import { getGatewaysById, getSensorsByQuery } from "components/axios/iotAxios";
import { useState } from "react";
import dayjs from "utils/dayjs";
import { getEquipmentsByQuery } from "components/axios/equipmentAxios";
import { useEnumApi } from "contexts/EnumApiContext";
import { fromServerFormat, nowTime } from "components/date_picker/dateUtils";

const GatewayViewSetting = () => {
  const { getEnumValueByEnumNameAndCode } = useEnumApi();
  const { t } = useTranslation();

  const {id} = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [gateway, setGateway] = useState({});
  const [sensors, setSensors] = useState([]);
  const [equipments, setEquipments] = useState([]);
  // const connectProblemDay = dayjs.tz().subtract(7, "day").format(t('message.common.text.date.format.date'));
  // useMemo를 사용해 컴포넌트가 렌더링될 때 한 번만 계산
  const connectProblemDay = React.useMemo(() => {
      const tz = process.env.REACT_APP_TIMEZONE || "Asia/Seoul";
      const fmt = t('message.common.text.date.format.date');
      
      // fmt가 유효한지 확인 후 처리
      const day = dayjs().tz(tz).subtract(7, "day");
      return day.isValid() ? day.format(fmt) : day.format("YYYY-MM-DD");
  }, [t]);

  useEffect(()=>{
    if (!isLoading) {
      Promise.all([
        getGatewaysById(id).then((res)=>{
          setGateway(res);
        })
        ,
        getSensorsByQuery({"gateway.id":id}).then((res3)=>{
          if (res3 && res3._embedded)
            setSensors(res3._embedded.sensors);
        })
        ,
        getEquipmentsByQuery({"gateways.gateway.id":id}).then((res4)=>{
          if (res4 && res4._embedded)
            setEquipments(res4._embedded.equipments);
        })
      ]).then(()=>{
        setIsLoading(true);
      })
    }
  },[isLoading, id]);

  if (isLoading && gateway) {
      let connectProblemColor = "view_td2";
      let diffDate = 0;
      if (gateway.latestCommedAt) {
        if (gateway.latestCommedAt && gateway.latestCommedAt < connectProblemDay) {
            connectProblemColor = "view_td2 red";
        }
        const latestComm = dayjs.tz(gateway.latestCommedAt, process.env.REACT_APP_TIMEZONE);
        const now = dayjs().tz(process.env.REACT_APP_TIMEZONE);
        diffDate = Math.abs(now.diff(latestComm, 'day'));

        // diffDate = ((nowTime() - new Date(gateway.latestCommedAt).getTime()) / (24*60*60*1000)).toFixed(0);
        // diffDate = ((nowTime() - dayjs.tz(gateway.latestCommedAt, process.env.REACT_APP_TIMEZONE).valueOf()) / (24*60*60*1000)).toFixed(0);
      } else {
        connectProblemColor = "view_td2 red";
      }

      return (
      <div style={{padding:"15px 0"}}>
          <Row>
            <Col sm={8} className="main_left">
              <div style={{marginBottom:"10px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.title.gateway.information')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
              </div>
  
              <TableContainer key={0}>
                <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width view_table" style={{borderTop:"2px solid #a2a2a2"}} >
                  <TableBody>
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.manufacturing.company')}</TableCell>
                      <TableCell className="view_td2">
                      {gateway.madeBy}&nbsp;
                      </TableCell>
                      <TableCell className="th">S/N</TableCell>
                      <TableCell className="view_td2">{gateway.sn}&nbsp;</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.installation.date')}</TableCell>
                      <TableCell className="view_td2">{gateway.instlYmd}&nbsp;</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.last.communication')}</TableCell>
                      <TableCell className={connectProblemColor}>{gateway.latestCommedAt && diffDate+t('message.common.text.day.ago')}&nbsp;</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
  
              <br/>
              <div style={{marginBottom:"10px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.title.connection.sensor')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
              </div>
              <TableContainer key={2}>
                <Table className="list_table" sx={{ minWidth: 400 }} aria-label="simple table" style={{borderTop:"2px solid #a2a2a2"}}>
                  <TableBody>
                    <TableRow>
                      <TableCell className="th">No.</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.manufacturing.company')}</TableCell>
                      <TableCell className="th">S/N</TableCell>
                      <TableCell className="th">X, Y, Z</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.last.communication')}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.installation.date')}</TableCell>
                    </TableRow>
                    { sensors && sensors.map(function(con, i) {
                      connectProblemColor = "view_td2";
                      if (sensors[i].latestCommedAt) {
                        if (sensors[i].latestCommedAt && fromServerFormat(sensors[i].latestCommedAt, {format:t('message.common.text.date.format.date')}) < connectProblemDay) {
                            connectProblemColor = "view_td2 red";
                        }
                        const latestComm = dayjs.tz(sensors[i].latestCommedAt, process.env.REACT_APP_TIMEZONE);
                        const now = dayjs().tz(process.env.REACT_APP_TIMEZONE);
                        diffDate = Math.abs(now.diff(latestComm, 'day'));
                        // diffDate = ((nowTime() - new Date(sensors[i].latestCommedAt).getTime()) / (24*60*60*1000)).toFixed(0);
                      } else {
                        connectProblemColor = "view_td2 red";
                      }
                      return(
                    <TableRow key={i}>
                      <TableCell align="center">{sensors.length-i}</TableCell>
                      <TableCell align="center">{sensors[i].madeBy}&nbsp;</TableCell>
                      <TableCell align="center">{sensors[i].sn}</TableCell>
                      <TableCell align="center">
                        {sensors[i].axial && getEnumValueByEnumNameAndCode("SensorDirection", sensors[i].axial)?.[0]?.title}
                        {sensors[i].radial && ', '+getEnumValueByEnumNameAndCode("SensorDirection", sensors[i].radial)?.[0]?.title}
                        {sensors[i].vertical && ', '+getEnumValueByEnumNameAndCode("SensorDirection", sensors[i].vertical)?.[0]?.title}
                      </TableCell>
                      <TableCell align="center" className={connectProblemColor}>{sensors[i].latestCommedAt && diffDate+t('message.common.text.day.ago')}</TableCell>
                      <TableCell align="center">{sensors[i].instlYmd}</TableCell>
                    </TableRow>
                      )
                  }) }
                  </TableBody>
                </Table>
              </TableContainer>

              <div style={{marginTop:"10px"}}>
                  <Link to={'../'+window.location.search}><Button variant="contained" color="primary">{t('message.common.btn.list')}</Button></Link>
              </div>
            </Col>
  
            <Col sm={4} className="main_right">
              <div style={{marginBottom:"10px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.title.target.equipment.information')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
              </div>

  
              { equipments && equipments.map(function(con, i) {
                  return(
              <TableContainer key={i}>
                <Table sx={{ minWidth: 400 }} aria-label="simple table" className="same_width view_table" style={{borderTop:"2px solid #a2a2a2"}} >
                  <TableBody>
                    {equipments[i].managementCompany &&
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.company.name')}</TableCell>
                      <TableCell className="view_td" colSpan={3}>
                        {equipments[i].managementCompany?.info?.name}
                      </TableCell>
                    </TableRow>
                    }
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.name')}</TableCell>
                      <TableCell className="view_td" colSpan={3}>
                        {equipments[i].name}({equipments[i].equipmentNo})
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
                  )
              })}
            </Col>
          </Row>
      </div>
      )
  }
}

export default GatewayViewSetting;